import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
    return {
        dialogTitle: {
            cursor: 'move',
        },
    };
});
